import React from 'react'
import PropTypes from 'prop-types'
import { Col, Row } from 'react-styled-flexboxgrid'
import { Link } from 'gatsby'
import { Section, Button } from '..'
import book from '../../../assets/icons/book.svg'
import code from '../../../assets/icons/code.svg'
import blocks from '../../../assets/icons/blocks.svg'
import * as styles from './styles'

const propTypes = {
  data: PropTypes.object.isRequired
}

export default function DeveloperGetStarted({ data }) {
  return (
    <styles.Container>
      <styles.GetStartedContainer>
        <Row>
          <Col xs={12}>
            <styles.GetStartedHeader>
              {data.developersSection2Header}
            </styles.GetStartedHeader>
          </Col>
        </Row>
        <Section>
          <styles.CardRow>
            <styles.CardCol md={4} xs={12}>
              <styles.CardContainer>
                <styles.CardHeader>
                  {data.developersSection2Card1Header}
                </styles.CardHeader>
                <styles.CardImageContainer>
                  <styles.CardImage src={book} className="book" />
                </styles.CardImageContainer>
                <styles.CardText>
                  {data.developersSection2Card1Text}
                </styles.CardText>
                <a href={data.developersSection2Card1Button.url}>
                  <Button size="small" color="darkSuccess" fontColor="white">
                    {data.developersSection2Card1Button.text}
                  </Button>
                </a>
              </styles.CardContainer>
            </styles.CardCol>
            <styles.CardCol md={4} xs={12}>
              <styles.CardContainer>
                <styles.CardHeader>
                  {data.developersSection2Card2Header}
                </styles.CardHeader>
                <styles.CardImageContainer>
                  <styles.CardImage src={code} className="code" />
                </styles.CardImageContainer>
                <styles.CardText>
                  {data.developersSection2Card2Text}
                </styles.CardText>
                <a href={data.developersSection2Card2Button.url}>
                  <Button size="small" color="darkSuccess" fontColor="white">
                    {data.developersSection2Card2Button.text}
                  </Button>
                </a>
              </styles.CardContainer>
            </styles.CardCol>
            <styles.CardCol md={4} xs={12}>
              <styles.CardContainer>
                <styles.CardHeader>
                  {data.developersSection2Card3Header}
                </styles.CardHeader>
                <styles.CardImageContainer>
                  <styles.CardImage src={blocks} className="blocks" />
                </styles.CardImageContainer>
                <styles.CardText>
                  {data.developersSection2Card3Text}
                </styles.CardText>
                <a href={data.developersSection2Card3Button.url}>
                  <Button size="small" color="darkSuccess" fontColor="white">
                    {data.developersSection2Card3Button.text}
                  </Button>
                </a>
              </styles.CardContainer>
            </styles.CardCol>
          </styles.CardRow>
        </Section>

        <styles.GetStartedText>
          {data.developersSection2FooterText}
          {' '}
          <Link to={data.developersSection2FooterLink.url}>
            {data.developersSection2FooterLink.text}
          </Link>
        </styles.GetStartedText>
      </styles.GetStartedContainer>
    </styles.Container>
  )
}

DeveloperGetStarted.propTypes = propTypes
